//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {selectCtripsPerson} from "@/api/contract/payRecord";

export default {

name: "ctripPersonInfo",
  data() {
    return {
      ctripPerson:{},
      taskParam:{},
    }
    },
  created(){
    if(this.$route.query.id==undefined){

    }else{
      if(this.$route.query.taskParam!==''){
        this.taskParam=this.$route.query.taskParam;
      }
      var data = {'id':this.$route.query.id};
      selectCtripsPerson(data).then(response => {
        this.ctripPerson=response;
      });

    }
  },
  methods:{
    returnList() {
      if(this.taskParam!=undefined){
        this.$router.push({path:'/payRecord/payCtripDetail',query:{id:this.taskParam.businessKey,taskParam:this.taskParam}})

      }else{
        this.$router.push({path:'/payRecord/payCtripDetail',query:{id:this.ctripPerson.payId}})

      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/view/payRecord/detail/ctripPersonInfo.vue